module.exports = __webpack_public_path__ + "img/image34.675b8a37.png";